// extracted by mini-css-extract-plugin
export default {"item":"CommentItem_item__xMXZ4"};